import Lenis from 'lenis';

/**
 * Single smooth-scroll instance for the page. Lenis drives the native scroll
 * position, so CSS sticky, Motion's useScroll and anchors keep working.
 * Disabled entirely under reduced motion.
 */
let lenis: Lenis | null = null;

/** Latest scroll velocity (px per frame), read by the WebGL scenes. */
export const scrollState = { velocity: 0 };

export function startSmoothScroll() {
  if (lenis || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return lenis;
  }
  lenis = new Lenis({
    autoRaf: true,
    anchors: { offset: 0 },
    lerp: 0.09,
    wheelMultiplier: 0.95,
  });
  lenis.on('scroll', (l: Lenis) => {
    scrollState.velocity = l.velocity;
  });
  return lenis;
}

export function stopSmoothScroll() {
  lenis?.destroy();
  lenis = null;
  scrollState.velocity = 0;
}

export const getLenis = () => lenis;
